import { useCallback, useState } from "react";
import { Alert, Avatar, Flex, Group, Paper, Stack, Text } from "@mantine/core";
import { IconAlertTriangle, IconUpload, IconX } from "@tabler/icons-react";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { rem } from "@mantine/core";
import FileSize from "./FileSize";

function FileUploaderSimple({ onFileSelected }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [rejectionError, setRejectionError] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    setRejectionError(null);
    setSelectedFile(acceptedFiles[0]);
    onFileSelected(acceptedFiles[0]);
  }, [onFileSelected]);

  const onReject = useCallback(
    (fileRejections) => {
      const code = fileRejections?.[0]?.errors?.[0]?.code;
      let message = "That file can't be uploaded.";
      if (code === "file-too-large") {
        message = "That file is larger than 2 MB. Please upload a smaller file.";
      } else if (code === "file-invalid-type") {
        message = "Please upload a .csv or .xlsx file.";
      }
      setRejectionError(message);
      setSelectedFile(null);
      onFileSelected(null);
    },
    [onFileSelected]
  );

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Dropzone
        onDrop={onDrop}
        multiple={false}
        onReject={onReject}
        maxSize={2 * 1024 ** 2}
        accept={[MIME_TYPES.csv, MIME_TYPES.xlsx]}

      >
        <Flex
          m="md"
          align="center"
          justify="center"
          mih={60}
          style={{ pointerEvents: "none" }}
        >
          <Dropzone.Accept>
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconUpload size={55} stroke={1.8} />
            </Avatar>
          </Dropzone.Accept>
          <Dropzone.Reject component="div">
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconX
                style={{
                  width: rem(52),
                  height: rem(52),
                  color: "var(--mantine-color-red-6)",
                }}
                stroke={1.8}
              />
            </Avatar>
          </Dropzone.Reject>
          <Group justify="center" gap="md" align="center">
            <IconUpload size={38} stroke={1.5} />
            <Stack align="center" gap={2}>
              <Text ta="center" size="lg" fw={500}>
                Drag or click to upload
              </Text>
              <Text c="dimmed">.csv or .xlsx, 2MB max</Text>
            </Stack>
          </Group>
        </Flex>
      </Dropzone>
      {rejectionError ? (
        <Alert
          my="md"
          color="red"
          variant="light"
          icon={<IconAlertTriangle size={16} />}
        >
          {rejectionError}
        </Alert>
      ) : null}
      {selectedFile ? (
        <Paper my="md" p="md" withBorder>
          <Text size="lg" mb="md">
            {selectedFile.name}
          </Text>
          <FileSize size={selectedFile.size} />
          <Text size="sm" c="dimmed">
            {selectedFile.type}
          </Text>
        </Paper>
      ) : null}
    </div>
  );
}

export default FileUploaderSimple;
